import { render, staticRenderFns } from "./DeleteRes.vue?vue&type=template&id=24c18090&"
import script from "./DeleteRes.vue?vue&type=script&lang=js&"
export * from "./DeleteRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports